// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Tcb1","content":"styles_content__3BPwS","tableWrap":"styles_tableWrap__1nW7P"};